import request from '@/utils/request'

/**
 * Simple RESTful resource class
 */
class Resource {
    constructor(uri, requestInstance) {
        this.uri = uri
        this._request = requestInstance || request
        console.log('Resource', this.uri, this._request)
    }
    list(query) {
        console.log('list', this.uri, query)
        return this._request({
            url: this.uri,
            method: 'get',
            params: query,
        })
    }
    get(id) {
        return this._request({
            url: this.uri + '/' + id,
            method: 'get',
        })
    }
    store(resource) {
        return this._request({
            url: this.uri,
            method: 'post',
            data: resource,
        })
    }
    update(id, resource) {
        return this._request({
            url: this.uri + '/' + id,
            method: 'put',
            data: resource,
        })
    }
    destroy(id) {
        return this._request({
            url: this.uri + '/' + id,
            method: 'delete',
        })
    }
}

export { Resource as default }
